import types from './types';
import {
    fetchElement
} from './common';
const apiUrl = '/api/statistics';
export function fetchStatistics() {

    return fetchElement(apiUrl, '', types.LOAD_STATISTICS);
}



// WEBPACK FOOTER //
// ./src/js/actions/statistics.js